import { Alert, Button, List } from "reactstrap";

export const ExternalProjectInfo = ({
  unitsByOrganizationCount,
  unitsByOrganization,
  translate,
  openOrganizationUpdateModal,
}) => {
  const userIsManagerForAllProjects =
    unitsByOrganization?.length === unitsByOrganizationCount;
  return (
    <>
      <Alert>
        {unitsByOrganizationCount > 0 && (
          <h4 className="alert-heading">
            {`${translate(
              "organizationUnit.header"
            )} ${unitsByOrganizationCount}
            ${translate("organizationUnit.projects")}`}
          </h4>
        )}

        {unitsByOrganization?.length > 0 && (
          <>
            <p>{translate("organizationUnit.managerHeader")}</p>
            <List>
              {unitsByOrganization.map(({ project }, index) => (
                <li key={index}>{project.code}</li>
              ))}
            </List>

            {userIsManagerForAllProjects && (
              <Button onClick={openOrganizationUpdateModal} color="success">
                {translate("organizationUnit.updateButton")}
              </Button>
            )}
          </>
        )}
      </Alert>
    </>
  );
};
